import axios from 'axios';
import {
	utilityService
} from '@/services/utilityService.js';

export const searchHistoryService = {
	saveSearchHistoryItem,
	getSearchHistory,
	deleteSeachHistoryItem,
	deleteAllSearchHistory
};

function saveSearchHistoryItem (criteria, study, key) {
	if (!criteria || !study || !key) {
		return false;
	}
	var sh = this.getSearchHistory(study, key);
	let ableToPush = true
	for (let piece of sh) {
		if (piece.study === criteria.study && piece.startdate === criteria.startdate && piece.enddate === criteria.enddate && JSON.stringify(piece.status) === JSON.stringify(criteria.status) && piece.spid === criteria.spid && piece.staff === criteria.staff && piece.dataType === criteria.dataType) {
			ableToPush = false
		}
	}
	if (criteria.dataType !== "Tasks") {
		ableToPush = false
	}
	if (ableToPush) {
		if (sh) {
			if (sh.length >= 20) {
				sh.shift();
				sh.push(criteria);
			} else {
				sh.push(criteria);
			}
		} else {
			sh = [];
			sh.push(criteria);
		}
	}
	localStorage.setItem('history', JSON.stringify(sh))
	return true
}

function getSearchHistory (study, key) {
	if (!study || !key) {
		return null;
	}
	var tempArrayHis = JSON.parse(localStorage.getItem('history')) || []
	let filteredHistory = []
	for (let piece of tempArrayHis) {
		if (piece.study === study) {
			filteredHistory.push(piece)
		}
	}
	return filteredHistory
}

function deleteSeachHistoryItem (index, study, key) {
	if (index < 0 || !study || !key) {
		return false;
	}
	var myHistory = JSON.parse(localStorage.getItem('history'))
	var filteredHistory = []
	for (let piece of myHistory) {
		if (piece.study === study) {
			filteredHistory.push(piece)
		}
	}
	var delIndex = filteredHistory[index]
	console.log('delIndex', delIndex)
	for (var i = 0; i < myHistory.length; i++) {
		if (myHistory[i] === delIndex) {
			myHistory.splice(i, 1);
		}
	}
	localStorage.setItem('history', JSON.stringify(myHistory));
	return true;
}

function deleteAllSearchHistory (study, key) {
	var tempArrayHis = JSON.parse(localStorage.getItem('history')) || []
	var filtered = tempArrayHis.filter(function (value, index, arr) {
		return value.study !== study;
	});
	localStorage.setItem('history', JSON.stringify(filtered))
	return true
}
